"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ingestNarrationDataPartSchemas = exports.ingestBomReviewCtaDataSchema = exports.ingestChecklistEstimateFileSchema = exports.ingestChecklistEstimateCategorySchema = exports.INGEST_CHECKLIST_ESTIMATE_SCHEMA_VERSION = exports.ingestValidationChecklistDataSchema = exports.ingestValidationCategorySchema = exports.IngestValidationCategoryStatus = exports.ingestEngineBadgeSchema = exports.IngestEngineKind = exports.ingestActivityDataSchema = exports.ingestActivityLineSchema = exports.IngestActivityStatus = exports.EXPLORATION_TERMINAL_ROW_IDS = exports.EXPLORATION_FALLBACK_ROW_ID = exports.EXPLORATION_COMPLETION_ROW_ID = exports.ingestTaskListDataSchema = exports.ingestTaskItemSchema = exports.IngestTaskStatus = exports.ingestStateDataSchema = exports.IngestNarrationPhase = exports.INGEST_NARRATION_STATE_PART_TYPE = exports.INGEST_NARRATION_FINALE_MESSAGE_ID = exports.INGEST_NARRATION_OPENING_MESSAGE_ID = void 0;
const z = require("zod");
exports.INGEST_NARRATION_OPENING_MESSAGE_ID = 'msg-ingest-narration-opening';
exports.INGEST_NARRATION_FINALE_MESSAGE_ID = 'msg-ingest-narration-finale';
exports.INGEST_NARRATION_STATE_PART_TYPE = 'data-ingest-state';
var IngestNarrationPhase;
(function (IngestNarrationPhase) {
    IngestNarrationPhase["Narrating"] = "narrating";
    IngestNarrationPhase["Complete"] = "complete";
})(IngestNarrationPhase || (exports.IngestNarrationPhase = IngestNarrationPhase = {}));
exports.ingestStateDataSchema = z.object({
    phase: z.nativeEnum(IngestNarrationPhase),
    openingSettled: z.boolean().optional(),
});
var IngestTaskStatus;
(function (IngestTaskStatus) {
    IngestTaskStatus["Pending"] = "pending";
    IngestTaskStatus["Active"] = "active";
    IngestTaskStatus["Done"] = "done";
})(IngestTaskStatus || (exports.IngestTaskStatus = IngestTaskStatus = {}));
exports.ingestTaskItemSchema = z.object({
    id: z.string(),
    label: z.string(),
    status: z.nativeEnum(IngestTaskStatus),
    detail: z.string().optional(),
});
exports.ingestTaskListDataSchema = z.object({
    title: z.string().optional(),
    tasks: z.array(exports.ingestTaskItemSchema),
});
exports.EXPLORATION_COMPLETION_ROW_ID = 'exploration-complete';
exports.EXPLORATION_FALLBACK_ROW_ID = 'exploration-fallback';
exports.EXPLORATION_TERMINAL_ROW_IDS = [
    exports.EXPLORATION_COMPLETION_ROW_ID,
    exports.EXPLORATION_FALLBACK_ROW_ID,
];
var IngestActivityStatus;
(function (IngestActivityStatus) {
    IngestActivityStatus["Running"] = "running";
    IngestActivityStatus["Done"] = "done";
    IngestActivityStatus["Error"] = "error";
})(IngestActivityStatus || (exports.IngestActivityStatus = IngestActivityStatus = {}));
exports.ingestActivityLineSchema = z.object({
    id: z.string(),
    label: z.string(),
    detail: z.string().optional(),
    status: z.nativeEnum(IngestActivityStatus),
});
exports.ingestActivityDataSchema = z.object({
    lines: z.array(exports.ingestActivityLineSchema),
});
var IngestEngineKind;
(function (IngestEngineKind) {
    IngestEngineKind["Engine"] = "engine";
    IngestEngineKind["Ai"] = "ai";
})(IngestEngineKind || (exports.IngestEngineKind = IngestEngineKind = {}));
exports.ingestEngineBadgeSchema = z.object({
    label: z.string(),
    kind: z.nativeEnum(IngestEngineKind),
});
var IngestValidationCategoryStatus;
(function (IngestValidationCategoryStatus) {
    IngestValidationCategoryStatus["Pending"] = "pending";
    IngestValidationCategoryStatus["Counting"] = "counting";
    IngestValidationCategoryStatus["Queued"] = "queued";
})(IngestValidationCategoryStatus || (exports.IngestValidationCategoryStatus = IngestValidationCategoryStatus = {}));
exports.ingestValidationCategorySchema = z.object({
    id: z.string(),
    label: z.string(),
    engines: z.array(exports.ingestEngineBadgeSchema),
    valueText: z.string().nullable(),
    status: z.nativeEnum(IngestValidationCategoryStatus),
});
exports.ingestValidationChecklistDataSchema = z.object({
    title: z.string(),
    totalText: z.string(),
    totalCaption: z.string(),
    categories: z.array(exports.ingestValidationCategorySchema),
});
exports.INGEST_CHECKLIST_ESTIMATE_SCHEMA_VERSION = 1;
exports.ingestChecklistEstimateCategorySchema = z.object({
    id: z.string(),
    label: z.string(),
    engines: z.array(exports.ingestEngineBadgeSchema),
    count: z.number().int().nonnegative().nullable(),
    valueText: z.string(),
});
exports.ingestChecklistEstimateFileSchema = z.object({
    schemaVersion: z.literal(exports.INGEST_CHECKLIST_ESTIMATE_SCHEMA_VERSION),
    projectModelId: z.string(),
    generatedAt: z.string(),
    categories: z.array(exports.ingestChecklistEstimateCategorySchema),
    total: z.number().int().nonnegative(),
});
exports.ingestBomReviewCtaDataSchema = z.object({
    headline: z.string(),
    body: z.string(),
    buttonLabel: z.string(),
});
exports.ingestNarrationDataPartSchemas = {
    'ingest-state': exports.ingestStateDataSchema,
    'ingest-task-list': exports.ingestTaskListDataSchema,
    'ingest-activity': exports.ingestActivityDataSchema,
    'ingest-validation-checklist': exports.ingestValidationChecklistDataSchema,
    'ingest-bom-review-cta': exports.ingestBomReviewCtaDataSchema,
};
//# sourceMappingURL=ingest-narration.js.map